<template>
  <transition name="el-fade-in">
    <div class="mask" v-if="MarketingShow">
      <div class="dlog2" v-if="MarketingShow">
        <div class="dlog2Content" :style="MarketingInfo.popupBgImg ? `background-image: url(${MarketingInfo.popupBgImg});` : ''">
          <img src="https://img.webloom.cn/Img/cujiuaofeiClose.png" alt="" class="dlog2Colse" @click="closeDialog">
          <div class="title">{{MarketingInfo.topicTitle}}</div>
          <div class="text" v-if="MarketingInfo && MarketingInfo.topicDesc">{{ MarketingInfo.topicDesc }}</div>

          <!-- 动态内容展示 -->
          <div class="dlog2Content-main" v-if="MarketingInfo" id="dlog2Content-main">
            <div class="dlog2Content-main-title1" id="activityName">{{ MarketingInfo.activityName || '限时优惠活动' }}</div>
            <div class="dlog2Content-main-title2" id="activityDesc">{{ MarketingInfo.activityDesc || '限时立减' }}</div>
            <div class="priceBox">
              <div class="txt1">当前价格</div>
              <div class="txt2">¥{{ MarketingInfo.currentPrice ? MarketingInfo.currentPrice / 100 : 0 }}</div>
              <div class="txt3">¥{{ MarketingInfo.originalPrice ? MarketingInfo.originalPrice / 100 : 0  }}</div>
            </div>
            <div class="tipBox" v-if="MarketingInfo.discountInfo">
              <div class="tip">
                <img src="https://img.webloom.cn/Img/cujiuaofeisjx.png" alt="" class="tipImg">
                {{ MarketingInfo.discountInfo }}
              </div>
            </div>
            <div class="btnBox">
              <div class="btn" @click="handleToMarketing" id="btn">
                <div class="btnTip">
                  <div class="btnTiptxt1" >{{MarketingInfo.timeLimitTxt || '优惠即将失效'}}</div>
                  <div class="btnTiptxt2" v-if="timeLimit">{{ remainingTxt }}</div>
                </div>
                前往缴费
              </div>
            </div>
            <div class="look">
              <div class="lookTip" @click="handleToMarketing">{{MarketingInfo.bottomTips}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PaymentGuideDialog',
  props: {
    // 控制弹窗是否展示
    MarketingShow: {
      type: Boolean,
      default: false
    },
    // 标识当前所在页面
    page: {
      type: String,
      default: ''
    },
    // 限时优惠配置信息
    MarketingInfo: {
      type: Object,
      default: () => ({})
    },
    // 按钮点击时的回调方法
    toMarketing: {
      type: Function,
      default: () => {}
    },
    // 倒计时时间（秒）
    remainingTime: {
      type: Number,
      default: 0
    },
    remainingTxt: {
      type: String,
      default: '00:00:00'
    },
    // 是否限时 不限时不需要展示弹窗里面的倒计时
    timeLimit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 定时器
      timer: null
    }
  },
  computed: {

  },
  methods: {
    // 关闭弹窗
    closeDialog () {
      this.$emit('update:MarketingShow', false)
    },
    // 处理营销按钮点击
    handleToMarketing () {
      this.closeDialog()
      if (typeof this.toMarketing === 'function') {
        this.toMarketing()
      }
    },
    // 初始化数据
    init () {
      this.$nextTick(() => {
        let popupBgColor = this.MarketingInfo.popupBgColor ? this.MarketingInfo.popupBgColor : ''
        let popupTxtColor = this.MarketingInfo.popupTxtColor ? this.MarketingInfo.popupTxtColor : ''
        let popupBtnColor = this.MarketingInfo.popupBtnColor ? this.MarketingInfo.popupBtnColor : ''
        popupBgColor = popupBgColor.split(',')
        popupTxtColor = popupTxtColor.split(',')
        popupBtnColor = popupBtnColor.split(',')
        // 改弹窗背景颜色
        let dlog2ContentMain = document.getElementById('dlog2Content-main')
        if (dlog2ContentMain && popupBgColor && popupBgColor.length > 0) {
          if (popupBgColor.length > 1) {
            // 渐变
            dlog2ContentMain.setAttribute('style', `background: linear-gradient( 180deg, ${popupBgColor[0]} 0%, ${popupBgColor[1]} 100%)`)
          } else {
            // 纯色
            dlog2ContentMain.setAttribute('style', `background: ${popupBgColor[0]}`)
          }
        }
        // 改活动名称文案颜色
        let activityName = document.getElementById('activityName')
        let activityDesc = document.getElementById('activityDesc')
        if (popupTxtColor && popupTxtColor.length > 0) {
          if (popupTxtColor.length > 1) {
            // 渐变
            if (activityName) {
              activityName.setAttribute('style', `background: -webkit-linear-gradient(45deg, ${popupTxtColor[0]}, ${popupTxtColor[1]}); -webkit-background-clip: text; -webkit-text-fill-color: transparent;`)
            }
            if (activityDesc) {
              activityDesc.setAttribute('style', `background: -webkit-linear-gradient(45deg, ${popupTxtColor[0]}, ${popupTxtColor[1]}); -webkit-background-clip: text; -webkit-text-fill-color: transparent;`)
            }
          } else {
            // 纯色
            if (activityName) {
              activityName.setAttribute('style', `color: ${popupTxtColor[0]}`)
            }
            if (activityDesc) {
              activityDesc.setAttribute('style', `color: ${popupTxtColor[0]}`)
            }
          }
        }
        // 改按钮颜色
        let btn = document.getElementById('btn')
        if (btn && popupBtnColor && popupBtnColor.length > 0) {
          if (popupBtnColor.length > 1) {
            // 渐变
            btn.setAttribute('style', `background: linear-gradient( 270deg, ${popupBtnColor[0]} 0%, ${popupBtnColor[1]} 100%)`)
          } else {
            // 纯色
            btn.setAttribute('style', `background: ${popupBtnColor[0]}`)
          }
        }
        this.$forceUpdate()
      })
      this.$forceUpdate()
    }
  },
  watch: {
    MarketingShow: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.init()
      }
    },
    'MarketingInfo' () {
      this.init()
    }
  },
  mounted () {
  },
  beforeDestroy () {

  }
}
</script>

<style scoped lang="scss">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .dlog2 {
    width: 462px;
    border-radius: 8px;
    .dlog_title {
      .title_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 32px 0 40px;
        box-sizing: border-box;
        .title {
          box-sizing: border-box;
          font-family: PingFangSC-Medium, PingFang SC;
          //font-weight: 600;
          font-size: 20px;
          color: #030A17;
          text-align: left;
          font-style: normal;
        }
        .close {
          width: 16px;
          height: 16px;
          display: block;
        }
      }
      .title_bot {
        margin-top: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #170303;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        padding-bottom: 12px;
        border-bottom: 1px solid #D8D8D8;
        box-sizing: border-box;
        padding-left: 40px;
      }
    }
    .contentBox {
      margin-top: 36px;
      box-sizing: border-box;
      padding: 0 40px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #030A17;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      min-height: 110px;
      .PayTaskItem {
        width: 520px;
        height: 75px;
        background: #F5F8FF;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 24px;
        margin-bottom: 24px;
        .PayTaskTitle {
          .title {
            width: 352px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #030A17;
            line-height: 22px;
            text-align: left;
            font-style: normal;
          }
        }
        .toPayBtn {
          width: 96px;
          height: 36px;
          background: #296BFF;
          border-radius: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 36px;
          text-align: center;
          font-style: normal;
        }
      }
    }
    .dlog2Content {
      width: 462px;
      height: 538px;
      background-image: url("https://img.webloom.cn/Img/cujiuaofeiBg.png");
      background-size: 462px 185px;
      background-repeat: no-repeat;
      position: relative;
      .dlog2Colse {
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        right: 1px;
        top: 18px;
        cursor: pointer;
      }
      .title {
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 800;
        font-size: 30px;
        color: #FFFFFF;
        line-height: 42px;
        text-align: left;
        font-style: normal;
        margin: 0px 0 0 24px;
        padding-top: 43px;
      }
      .text {
        width: 286px;
        height: 44px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin: 10px 0 0 24px;
      }
      .dlog2Content-main{
        margin-top: 16px;
        width: 462px;
        height: 383px;
        background: linear-gradient( 180deg, #D1E0FF 0%, #FFFFFF 100%);
        border-radius: 23px;
        .dlog2Content-main-title1 {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #296BFF;
          line-height: 28px;
          text-align: center;
          font-style: normal;
          padding-top: 40px;
          //background: -webkit-linear-gradient(45deg, #296BFF, #2DA9FF);
          //-webkit-background-clip: text;
          //-webkit-text-fill-color: transparent;
        }
        .dlog2Content-main-title2 {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          font-size: 28px;
          color: #296BFF;
          line-height: 28px;
          text-align: center;
          font-style: normal;
          margin-top: 8px;
          //background: -webkit-linear-gradient(45deg, #296BFF, #2DA9FF);
          //-webkit-background-clip: text;
          //-webkit-text-fill-color: transparent;
        }
        .priceBox {
          display: flex;
          justify-content: center;
          align-items: end;
          margin-top: 34px;
          .txt1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #9199A0;
            line-height: 14px;
            text-align: left;
            font-style: normal;
          }
          .txt2 {
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            font-size: 32px;
            color: #F5625B;
            line-height: 32px;
            text-align: left;
            font-style: normal;
            padding: 0 16px;
          }
          .txt3 {
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 400;
            font-size: 20px;
            color: #7F899E;
            line-height: 20px;
            text-align: left;
            text-decoration: line-through;
          }
        }
        .tipBox {
          display: flex;
          justify-content: center;
          margin-top: 12px;
          .tip {
            padding: 4px 9px;
            position: relative;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FF811A;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            width: fit-content;
            background: #FFEEE1;
            border-radius: 5px;
            .tipImg {
              width: 12px;
              height: 6px;
              position: absolute;
              top: -6px;
              left: 50%;
              margin-left: -6px;
            }
          }
        }
        .btnBox {
          margin-top: 61px;
          display: flex;
          justify-content: center;
          .btn {
            position: relative;
            width: 330px;
            height: 53px;
            background: #296BFF;
            border-radius: 26px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 53px;
            text-align: center;
            font-style: normal;
            cursor: pointer;
            .btnTip {
              height: 34px;
              box-sizing: border-box;
              padding: 5px 7px;
              background: linear-gradient( 249deg, #FF766C 0%, #F54941 100%);
              border-radius: 73px 73px 73px 0px;
              display: flex;
              position: absolute;
              bottom: 40px;
              right: -43px;
              display: flex;
              align-items: end;
              .btnTiptxt1 {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                height: 14px;
                line-height: 8px;
                position: relative;
                display: block!important;
              }
              .btnTiptxt2 {
                width: 100px;
                font-size: 20px;
                height: 20px;
                position: relative;
                display: block;
                display: block!important;
                line-height: 16px;
                font-style: italic;
              }
            }
          }

        }
        .look {
          display: flex;
          justify-content: center;
          margin-top: 18px;
          .lookTip {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #9199A0;
            line-height: 14px;
            text-align: center;
            font-style: normal;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/PaymentGuideDialog.vue